module.exports = __webpack_public_path__ + "254c50d78e7534a07e927c1c33053eb8.png";